// extracted by mini-css-extract-plugin
export default {"cFormSubmitValidation":"FormSubmitValidation_cFormSubmitValidation__pPOuy"};